import React, { useState } from 'react';
import './FormFieldsStyle.css';
 //import asteriskImg from "../../images/img/asterisk.png"


const InputField = (props) => {
   console.log("inputprops",props);
   const [value,setValue] = useState();
  

    const handleChange = (e) => {
       setValue(e.target.value)
       localStorage.setItem("inputValue", JSON.stringify({key1:e.target.value}))
    }

    return (
      <div className="form-group">
            <label className="sel" style={{fontSize:"16px", color:"#444444"}}>{props.item.text}
                <span className="asterisk-icon">
                {/* <img src={asteriskImg} alt="" /> */}
                </span> 
            </label>
            <input type="text" className="form-control" disabled={props.disable} defaultValue={props.userInputObj && props.userInputObj.key1 || ""} onInput={handleChange} />
            <span className="validate">&nbsp;</span> 
        </div>
       
    )
}

export default InputField;